import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../../atomic/text/Text';
import style from './AddGrabCents.module.css';

export const AddGrabCentsHeaderLeft = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Field
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Value
          </Body3>
        </th>
      </tr>
    </thead>
  );
};

export const AddGrabCentsHeaderRight = ({ mode }) => {
  return (
    <thead>
      <tr>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Profit per Level
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            {`${mode === 'PERCENT' ? 'Pct.' : 'Qty.'} per Level`}
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            +/-
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
AddGrabCentsHeaderRight.propTypes = {
  mode: PropTypes.string,
};
